module.exports = __webpack_public_path__ + "static/sabine-neurology-2217f66a53c2d74e3cf1438fe11139e0.jpg";